import React from 'react';
import './TermsOfUse.css';

const BasicPage = () => {
  return (
    <div className="terms-of-use content pt-0">
      <div className="row">
        <div className="card mb-2 mt-4">
          <div className="card-body">
            <h1>Términos de Uso</h1>
            <h2>1. Introducción</h2>
            <p>Bienvenido a [Nombre de la Aplicación]. Al utilizar nuestra aplicación, usted acepta cumplir con los presentes Términos de Uso. Si no está de acuerdo con alguno de estos términos, le pedimos que no utilice nuestra plataforma.</p>
            <h2>2. Licencia de Uso</h2>
            <p>Le concedemos una licencia limitada, no exclusiva e intransferible para acceder y utilizar la aplicación, siempre que cumpla con estos Términos de Uso.</p>
            <h2>3. Uso Aceptable</h2>
            <p>Al utilizar la aplicación, usted se compromete a:</p>
            <ul>
                <li>No usar la plataforma para actividades ilegales o no autorizadas.</li>
                <li>No intentar acceder a cuentas de otros usuarios sin su permiso.</li>
                <li>No descompilar, realizar ingeniería inversa ni intentar obtener el código fuente de la aplicación.</li>
            </ul>
            <h2>4. Propiedad Intelectual</h2>
            <p>Todo el contenido de la aplicación (diseño, texto, gráficos, logotipos, etc.) es propiedad exclusiva de [Nombre de la Empresa] o de sus licenciantes. Está prohibido copiar, modificar o distribuir cualquier contenido sin autorización expresa.</p>
            <h2>5. Limitación de Responsabilidad</h2>
            <p>[Nombre de la Empresa] no será responsable por daños directos o indirectos derivados del uso o la imposibilidad de uso de la aplicación, incluidos daños a su equipo, pérdida de datos o pérdidas económicas.</p>
            <h2>6. Modificaciones a los Términos</h2>
            <p>Nos reservamos el derecho a actualizar estos Términos de Uso en cualquier momento. Cualquier cambio será notificado a los usuarios de manera visible en la aplicación.</p>
            <h2>7. Jurisdicción</h2>
            <p>Estos Términos de Uso se regirán e interpretarán de acuerdo con las leyes de [jurisdicción aplicable]. Cualquier disputa relacionada con estos términos será resuelta ante los tribunales competentes de [ciudad o región].</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicPage;
